var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClasses(), on: { click: _vm.showField } }, [
    _c("div", { staticClass: "field-header" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLabel,
              expression: "showLabel"
            }
          ],
          staticClass: "field-label"
        },
        [_vm._v(_vm._s(_vm.customField.label))]
      ),
      _vm._v(" "),
      _vm.customField.field_type == "wysiwyg" &&
      _vm.customField.updated_at &&
      _vm.updatedOnTop == true
        ? _c("div", { staticClass: "last-updated" }, [
            _vm._v(
              "\n      Last updated " +
                _vm._s(
                  _vm._f("moment")(_vm.customField.updated_at, "MMM D HH:mm a")
                ) +
                "\n    "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.customField.field_type == "priority"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "div",
            {
              staticClass: "priority-rating",
              on: {
                click: function($event) {
                  return _vm.setPriority(_vm.customField)
                }
              }
            },
            [
              _c("vue-star-rate", {
                key: "del-priority-" + Math.random() + _vm.deliverable.id,
                attrs: {
                  rateRange: _vm.customField.value
                    ? Number(_vm.customField.value)
                    : 0,
                  maxIcon: 5,
                  iconHeight: 17,
                  iconWidth: 17,
                  hasCounter: false,
                  iconColor: "var(--wf-primary)",
                  iconColorHover: "var(--wf-primary)",
                  iconShape: "circle"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "wysiwyg"
      ? _c(
          "div",
          { staticClass: "field-wrap" },
          [
            _c("ckeditor", {
              ref: "customInput",
              attrs: {
                readOnly:
                  !_vm.userAbilities.editMediaCall ||
                  _vm.deliverable.permissions.viewOnly,
                editorUrl: "/js/ckeditor/ckeditor.js",
                id: "custom-field-" + _vm._uid,
                config: _vm.editorConfig
              },
              on: {
                input: function($event) {
                  _vm.changed = true
                },
                blur: function($event) {
                  return _vm.checkChangedFieldValue(_vm.customField)
                },
                ready: function($event) {
                  _vm.changed = false
                }
              },
              model: {
                value: _vm.customField.value,
                callback: function($$v) {
                  _vm.$set(_vm.customField, "value", $$v)
                },
                expression: "customField.value"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "textarea"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                },
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "exclude-outside-click field-value text-hover-bg",
              staticStyle: { "white-space": "pre-line" },
              attrs: { title: _vm.customField.value }
            },
            [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "field-value" }, [
            _c("textarea", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editing,
                  expression: "editing"
                },
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customField.value,
                  expression: "customField.value"
                }
              ],
              ref: "customInput",
              staticClass: "form-control custom-inputs",
              attrs: { rows: _vm.rows },
              domProps: { value: _vm.customField.value },
              on: {
                change: function($event) {
                  return _vm.updateFieldValue(_vm.customField)
                },
                blur: function($event) {
                  _vm.editing = false
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.customField, "value", $event.target.value)
                }
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "website"
      ? _c("div", { staticClass: "field-wrap" }, [
          !_vm.customField.value
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    },
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass:
                    "exclude-outside-click field-value text-hover-bg",
                  attrs: { title: _vm.customField.value }
                },
                [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.customField.value
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "resource-box"
                },
                [
                  _c("div", { staticClass: "media" }, [
                    _c("img", {
                      staticClass: "link-type-icon",
                      staticStyle: { "margin-right": "3px" },
                      attrs: {
                        src: require("@/csmworkflow/img/link-url.svg"),
                        draggable: "false"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "media-body" }, [
                      _c("div", { staticClass: "resource-box__url" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.customField.value,
                              target: "_blank",
                              id: _vm.customField.field_type
                            }
                          },
                          [_vm._v(_vm._s(_vm.customField.value))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "edit-resource-btn",
                          attrs: { title: "Edit website", href: "#" },
                          on: {
                            click: function($event) {
                              _vm.editing = true
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-edit" })]
                      )
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editing,
                  expression: "editing"
                }
              ],
              staticClass: "field-value"
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  }
                ],
                ref: "customInput",
                staticClass: "form-control custom-inputs",
                attrs: {
                  type: "url",
                  formatter: _vm.Format.website,
                  "lazy-formatter": ""
                },
                on: {
                  change: function($event) {
                    return _vm.formatWebsiteUrl()
                  }
                },
                model: {
                  value: _vm.customField.value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "value", $$v)
                  },
                  expression: "customField.value"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "select"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                }
              ],
              staticClass: "exclude-outside-click field-value text-hover-bg"
            },
            [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-field" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  }
                ],
                ref: "customInput",
                attrs: {
                  "show-labels": false,
                  options: _vm.getOptions,
                  multiple: false
                },
                on: {
                  close: function($event) {
                    _vm.editing = false
                  },
                  input: function($event) {
                    _vm.updateFieldValue(_vm.customField)
                    _vm.editing = false
                  }
                },
                model: {
                  value: _vm.customField.value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "value", $$v)
                  },
                  expression: "customField.value"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "status"
      ? _c("div", { staticClass: "field-wrap no-icon" }, [
          _vm.customField.value
            ? _c(
                "span",
                {
                  staticClass:
                    "exclude-outside-click field-value status-field-value",
                  style: {
                    backgroundColor:
                      _vm.parseValue(_vm.customField.value).color ||
                      _vm.customField.value.color
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.parseValue(_vm.customField.value).name ||
                        _vm.customField.value.name
                    )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.customField.value
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "exclude-outside-click field-value"
                },
                [_vm._v("Click to set...")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-field status-field" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  }
                ],
                ref: "customInput",
                attrs: {
                  searchable: false,
                  options: _vm.getOptions,
                  "custom-label": _vm.customLabel,
                  "show-labels": false
                },
                on: {
                  close: function($event) {
                    _vm.editing = false
                  },
                  input: function($event) {
                    return _vm.updateFieldValue(_vm.customField)
                  },
                  select: function($event) {
                    _vm.editing = false
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function(props) {
                        return [
                          _c(
                            "div",
                            {
                              style: {
                                color: "var(--wf-secondary)",
                                borderRadius: "10px",
                                backgroundColor: props.option.color,
                                height: "40px",
                                lineHeight: "40px",
                                textAlign: "center"
                              }
                            },
                            [_vm._v(_vm._s(props.option.name))]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2413709391
                ),
                model: {
                  value: _vm.customField.value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "value", $$v)
                  },
                  expression: "customField.value"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "users" && !_vm.isMultipleField
      ? _c(
          "div",
          { staticClass: "field-wrap no-icon custom-field-users-wrapper" },
          [
            _c("div", { staticClass: "field-value exclude-outside-click" }, [
              _c("span", { staticClass: "info-bubbles" }, [
                !_vm.customField.value
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "exclude-outside-click field-value",
                        staticStyle: { display: "inline-block" },
                        attrs: { title: "Click to set..." }
                      },
                      [_vm._v("Click to set...")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.customField.value && _vm.selectedUser
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "exclude-outside-click field-value",
                        class: {
                          "initials badge badge-primary": _vm.customField.value
                        },
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          title: _vm.selectedUser
                            ? _vm.selectedUser.name
                            : "Click to set..."
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("textInitials")(_vm.selectedUser.name)
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "add-multiselect-group",
                  class: [_vm.customField.value ? "l-65" : "l-145"]
                },
                [
                  _vm.customField.value ? _c("plus-button") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ],
                      staticClass: "custom-field user-field custom-multiselect"
                    },
                    [
                      _c("multiselect", {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.outside,
                            expression: "outside"
                          }
                        ],
                        ref: "customInput",
                        attrs: {
                          options: _vm.allActiveUsers,
                          "show-labels": false,
                          multiple: _vm.isMultipleField,
                          "open-direction": "bottom",
                          label: "name",
                          "track-by": "id"
                        },
                        on: {
                          close: function($event) {
                            _vm.editing = false
                          },
                          input: _vm.userSelect
                        },
                        model: {
                          value: _vm.selectedUser,
                          callback: function($$v) {
                            _vm.selectedUser = $$v
                          },
                          expression: "selectedUser"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "users" && _vm.isMultipleField
      ? _c(
          "div",
          { staticClass: "field-wrap no-icon custom-field-users-wrapper" },
          [
            _c(
              "div",
              { staticClass: "field-value exclude-outside-click" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      }
                    ],
                    staticClass: "custom-field user-field custom-multiselect"
                  },
                  [
                    _c("multiselect", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      ref: "customInput",
                      attrs: {
                        options: _vm.allActiveUsers,
                        "show-labels": false,
                        "close-on-select": false,
                        multiple: _vm.isMultipleField,
                        "open-direction": "bottom",
                        label: "name",
                        "track-by": "id"
                      },
                      on: {
                        close: function($event) {
                          _vm.editing = false
                        },
                        input: _vm.multipleUsersSelect
                      },
                      model: {
                        value: _vm.selectedUsers,
                        callback: function($$v) {
                          _vm.selectedUsers = $$v
                        },
                        expression: "selectedUsers"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selectedUsers.length == 0
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "exclude-outside-click field-value",
                        staticStyle: { display: "inline-block" },
                        attrs: { title: "Click to set..." }
                      },
                      [_vm._v("Click to set...")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.selectedUsers, function(sUser, index) {
                  return _vm.selectedUsers.length > 0
                    ? _c(
                        "span",
                        {
                          key: _vm.customField.field_key + "-" + index,
                          staticClass: "info-bubbles"
                        },
                        [
                          sUser.name
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass:
                                    "exclude-outside-click field-value initials badge badge-primary",
                                  staticStyle: { display: "inline-block" },
                                  attrs: {
                                    title:
                                      sUser && sUser.name
                                        ? sUser.name
                                        : "Click to set..."
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("textInitials")(sUser.name)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass:
                                    "exclude-outside-click field-value",
                                  staticStyle: { display: "inline-block" },
                                  attrs: { title: "Click to set..." }
                                },
                                [_vm._v(" Click to set...")]
                              )
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-multiselect-group" },
                  [_vm.selectedUsers.length > 0 ? _c("plus-button") : _vm._e()],
                  1
                )
              ],
              2
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "datepicker"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                }
              ],
              staticClass: "exclude-outside-click field-value text-hover-bg"
            },
            [
              _vm.customField.value
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("moment")(_vm.customField.value, "DD MMM, YYYY")
                      )
                    )
                  ])
                : _c("span", [_vm._v("No Date")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-field" },
            [
              _c(
                "vuejs-datepicker",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  ref: "customDatepicker",
                  attrs: {
                    format: _vm.customDateFormat,
                    name: "due_date",
                    "input-class": "custom-datepicker form-control",
                    typeable: true,
                    inline: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.updateFieldValue(_vm.customField)
                    },
                    closed: function($event) {
                      _vm.dateSelected = true
                    },
                    selected: function($event) {
                      _vm.dateSelected = true
                    }
                  },
                  model: {
                    value: _vm.customField.value,
                    callback: function($$v) {
                      _vm.$set(_vm.customField, "value", $$v)
                    },
                    expression: "customField.value"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "calender-header",
                      attrs: { slot: "beforeCalendarHeader" },
                      slot: "beforeCalendarHeader"
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "remove-dl-btn",
                          attrs: { variant: "text" },
                          on: { click: _vm.resetDeadline }
                        },
                        [_vm._v("Reset Date")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "today-btn",
                          attrs: { variant: "text" },
                          on: { click: _vm.onToday }
                        },
                        [_vm._v("Today")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "datetimepicker"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c("div", { staticClass: "custom-field-date-time-picker-wrapper" }, [
            _c("fieldset", { staticClass: "date-time" }, [
              _c("div", { staticClass: "date" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "vdp-datepicker exclude-outside-click text-hover-bg",
                    attrs: { tabindex: "0" },
                    on: {
                      click: function($event) {
                        _vm.editing = true
                      },
                      keyup: _vm.onWrapperKeyUp
                    }
                  },
                  [
                    _vm.postDate
                      ? _c("span", {
                          staticClass:
                            "exclude-outside-click vdp-datepicker__placeholder",
                          domProps: {
                            innerHTML: _vm._s(_vm.displayPostDate(_vm.postDate))
                          }
                        })
                      : _c(
                          "span",
                          {
                            staticClass:
                              "not-set exclude-outside-click vdp-datepicker__placeholder"
                          },
                          [_vm._v("No Date")]
                        )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      }
                    ],
                    staticClass: "custom-field date-pick-field",
                    on: {
                      keyup: function($event) {
                        $event.stopPropagation()
                        return _vm.onKeyUp.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c(
                      "DateTimePicker",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.outside,
                            expression: "outside"
                          }
                        ],
                        ref: "refDate",
                        attrs: {
                          "input-class": "form-control",
                          name: _vm.customField.field_key,
                          placeholder: "YYYY-MM-DD",
                          format: "yyyy-MM-dd",
                          inline: true,
                          typeable: true,
                          autofocus: true,
                          "calendar-class": "cf-datetime-calendar",
                          tabindex: "0"
                        },
                        on: {
                          closed: _vm.dateTimeUpdated,
                          input: _vm.dateTimeUpdated,
                          selected: _vm.setDefaultTime
                        },
                        model: {
                          value: _vm.postDate,
                          callback: function($$v) {
                            _vm.postDate = $$v
                          },
                          expression: "postDate"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "calender-header",
                            attrs: { slot: "beforeCalendarHeader" },
                            slot: "beforeCalendarHeader"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "remove-dl-btn",
                                attrs: { variant: "text" },
                                on: { click: _vm.resetDeadline }
                              },
                              [_vm._v("Reset Date/Time")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "today-btn",
                                attrs: { variant: "text" },
                                on: { click: _vm.onToday }
                              },
                              [_vm._v("Today")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "calender-footer",
                            attrs: { slot: "calendarFooter" },
                            slot: "calendarFooter"
                          },
                          [
                            _c("div", { staticClass: "time-wrapper" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.postTime,
                                    expression: "postTime"
                                  }
                                ],
                                ref: "refTime",
                                attrs: {
                                  type: "time",
                                  id: "cf_time_" + _vm.customField.field_key,
                                  name: "publish_time",
                                  tabindex: "1"
                                },
                                domProps: { value: _vm.postTime },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "escape",
                                        undefined,
                                        $event.key,
                                        undefined
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.stopPropagation()
                                    return _vm.onKeyUp.apply(null, arguments)
                                  },
                                  blur: _vm.dateTimeUpdated,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.postTime = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "today-btn",
                                attrs: { variant: "text", tabindex: "2" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onDone.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("Done")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "time" }, [
                _vm.postTime !== null
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postTime,
                          expression: "postTime"
                        }
                      ],
                      staticClass: "form-control cf-input",
                      attrs: {
                        type: "time",
                        id: "cf_time_" + _vm.customField.field_key,
                        name: "publish_time",
                        step: "60"
                      },
                      domProps: { value: _vm.postTime },
                      on: {
                        blur: _vm.dateTimeUpdated,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.postTime = $event.target.value
                        }
                      }
                    })
                  : _c("span", { staticClass: "time__placeholder" }, [
                      _vm._v("No Time")
                    ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "currency"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c("div", { staticClass: "currency-field" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editing,
                    expression: "!editing"
                  }
                ],
                staticClass: "exclude-outside-click edit-d-title"
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.customField.value
                      ? _vm.formatPrice(_vm.customField.value)
                      : "0.00"
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  }
                ],
                staticClass: "input-group"
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customField.value,
                      expression: "customField.value"
                    }
                  ],
                  ref: "customInput",
                  staticClass: "form-control",
                  attrs: { placeholder: _vm.customField.label },
                  domProps: { value: _vm.customField.value },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      _vm.editing = false
                    },
                    change: function($event) {
                      return _vm.updateFieldValue(_vm.customField)
                    },
                    blur: function($event) {
                      _vm.editing = false
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.customField, "value", $event.target.value)
                    }
                  }
                })
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "file"
      ? _c("span", [_c("input", { attrs: { type: "file" } })])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "radio"
      ? _c(
          "span",
          _vm._l(_vm.parseValue(_vm.customField.value_set), function(
            radioValue,
            index
          ) {
            return _c("label", { key: "radio" + index, staticClass: "ml-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.value,
                    expression: "customField.value"
                  }
                ],
                attrs: { type: "radio" },
                domProps: {
                  value: radioValue,
                  checked: _vm._q(_vm.customField.value, radioValue)
                },
                on: {
                  change: [
                    function($event) {
                      return _vm.$set(_vm.customField, "value", radioValue)
                    },
                    function($event) {
                      return _vm.updateFieldValue(_vm.customField)
                    }
                  ]
                }
              }),
              _vm._v("\n      " + _vm._s(radioValue) + "\n    ")
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "switch"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "div",
            { staticClass: "field-value custom-field-switcher-wrapper" },
            [
              _c(
                "div",
                { staticClass: "switch-toggle" },
                [
                  _vm._l(_vm.parseValue(_vm.customField.value_set), function(
                    radioValue,
                    index
                  ) {
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customField.value,
                            expression: "customField.value"
                          }
                        ],
                        staticClass: "no-focus-visible-outline",
                        attrs: {
                          type: "radio",
                          id: "cfsl_" + _vm.customField.field_key + "_" + index,
                          name: _vm.customField.field_key
                        },
                        domProps: {
                          value: JSON.stringify(radioValue),
                          checked: _vm.defaultCheckedValue == radioValue.slug,
                          checked: _vm._q(
                            _vm.customField.value,
                            JSON.stringify(radioValue)
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              _vm.$set(
                                _vm.customField,
                                "value",
                                JSON.stringify(radioValue)
                              )
                            },
                            function($event) {
                              return _vm.updateFieldValue(_vm.customField)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "no-focus-visible-outline",
                          attrs: {
                            for:
                              "cfsl_" + _vm.customField.field_key + "_" + index,
                            title: radioValue.name
                          }
                        },
                        [_vm._v(_vm._s(radioValue.name))]
                      )
                    ]
                  }),
                  _vm._v(" "),
                  _c("a", { staticClass: "btn no-focus-visible-outline" })
                ],
                2
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "wysiwyg" &&
    _vm.customField.updated_at &&
    _vm.updatedOnTop == false
      ? _c("div", { staticClass: "last-updated last-updated-below" }, [
          _vm._v(
            "\n    Last updated " +
              _vm._s(
                _vm._f("moment")(_vm.customField.updated_at, "MMM D HH:mm a")
              ) +
              "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("$")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }